import { useState } from "react";
import { NavItem, NavLink } from "reactstrap";
import { EMAIL_LIST } from "../../../Data/Email";
import { H4, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { EmailApplicationContainProp } from "../../../Type/EmailType";
import { Href } from "../../../Constant";

const ReademailList = ({ callback }: EmailApplicationContainProp) => {
  const [orgactiveTab, setorgActiveTab] = useState(1);

  return (
    <div className="inbox">
      {EMAIL_LIST.map((data, index) => (
        <NavItem key={index}>
          <NavLink className={`p-0 ${orgactiveTab === index ? "active" : ""}`} onClick={() => {
            setorgActiveTab(index + 1);
            callback(index + 1)}} href={Href}>
            <div className="d-flex">
              <div className="media-size-email">
                <Image className="me-3 rounded-circle" src={dynamicImage("user/user.png")} alt="image"/>
              </div>
              <div className="flex-grow-1">
                <H4>
                  {data.tittle}
                  <small>
                    <span className="ms-1 me-1">({data.date}</span>
                    {data.month}
                    <span className="ms-1">{data.year})</span>
                  </small>
                </H4>
                <P>{data.paragraph}</P>
              </div>
            </div>
          </NavLink>
        </NavItem>
      ))}
    </div>
  );
};

export default ReademailList;
